<template>
  <!-- page content -->
  <div class="bg-white py-6 px-4 sm:p-6 rounded">
    <div class="grid grid-cols-2 gap-6">
      <div class="col-span-2 sm:col-span-1">
        <label for="category" class="block text-sm font-medium text-gray-700"
          >Category</label
        >
        <select
          id="category"
          name="category"
          class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm"
          v-model="ticketData.category"
        >
          <option
            v-for="category in categories"
            :value="category.id"
            v-bind:key="category.id"
            >{{ category.name }}</option
          >
        </select>
      </div>
      <div class="col-span-2 sm:col-span-1">
        <label for="priority" class="block text-sm font-medium text-gray-700"
          >Select a Priority</label
        >
        <select
          id="priority"
          name="priority"
          class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm"
          v-model="ticketData.priority"
        >
          <option value="Low">Low</option>
          <option value="Medium">Medium</option>
          <option value="High">High</option>
        </select>
      </div>

      <div class="col-span-2">
        <label for="title" class="block text-sm font-medium text-gray-700"
          >Ticket Title</label
        >
        <input
          type="text"
          name="title"
          id="title"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm"
          v-model="ticketData.title"
        />
      </div>

      <div class="col-span-2">
        <label for="title" class="block text-sm font-medium text-gray-700"
          >Ticket Message</label
        >
        <textarea
          id="message"
          name="message"
          rows="3"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm"
          v-model="ticketData.message"
        ></textarea>
      </div>

      <div class="col-span-2 mt-2 ">
        <button
          class="px-3 py-1.5 bg-blue-600 text-white rounded focus:outline-none"
          v-on:click="addTicket"
        >
          Create Ticket
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import * as Config from "../../../config";
import { mapGetters } from "vuex";

export default {
  name: "Support",
  data() {
    return {
      ticketData: {
        category: null,
        title: null,
        priority: "Low",
        message: null
      },
      categories: []
    };
  },
  mounted() {
    this.getTicketCategories();
  },
  methods: {
    ...mapGetters(["getAuthorizationHeader"]),
    async getTicketCategories() {
      const response = await this.$http.get(
        Config.apiPath + "/api/v2/support/tickets/categories"
      );
      this.categories = response.data;
    },
    async addTicket() {
      if (
        this.ticketData.category == null ||
        this.ticketData.title == null ||
        this.ticketData.message == null
      ) {
        alert("All fields must be filled out before submitting the ticket.");
        return;
      }
      const postRes = await this.$http.post(
        Config.apiPath + "/api/v2/support/tickets/new",
        this.ticketData
      );
      if (postRes.data[0] == "success") {
        this.$router.push({ name: "StringerSupportTickets" });
      }
    }
  }
};
</script>
